export default __webpack_public_path__ + "static/media/B187.541652de.png";